import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";

export default function Oversized() {
  const [all, setAll] = useState([]);

  useEffect(() => {
    api.get("/products", { params: { subcategory: "oversized" } }).then((r) => setAll(r.data));
  }, []);

  const men = useMemo(() => all.filter((p) => p.category === "men"), [all]);
  const women = useMemo(() => all.filter((p) => p.category === "women"), [all]);

  return (
    <div>
      <div className="relative bg-[#3B2E22] text-[#F0E5D0] overflow-hidden border-b border-[#D4B25C]/10">
        <div className="max-w-7xl mx-auto px-6 py-20 grid md:grid-cols-2 gap-8 items-center">
          <div>
            <p className="label-tag text-[#D4B25C]/60 mb-4">Baggy · Boxy · Bold</p>
            <h1 className="font-display text-6xl sm:text-7xl font-black leading-none">
              OVERSIZED<br />
              <span className="text-[#D4B25C]">EDIT.</span>
            </h1>
            <p className="mt-6 text-white/70 max-w-md">Drop-shoulder cuts, boxy silhouettes, longer hems — the streetwear canvas your prints deserve.</p>
          </div>
          <div className="hidden md:block relative h-80">
            <img src="https://images.unsplash.com/photo-1503341504253-dff4815485f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" alt="" className="absolute inset-0 w-full h-full object-cover rounded-md" />
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-12">
        <Tabs defaultValue="all">
          <TabsList>
            <TabsTrigger data-testid="ov-tab-all" value="all">All ({all.length})</TabsTrigger>
            <TabsTrigger data-testid="ov-tab-men" value="men">Men ({men.length})</TabsTrigger>
            <TabsTrigger data-testid="ov-tab-women" value="women">Women ({women.length})</TabsTrigger>
          </TabsList>
          {[["all", all], ["men", men], ["women", women]].map(([k, arr]) => (
            <TabsContent key={k} value={k} className="mt-8">
              {arr.length === 0 ? (
                <p className="text-center text-muted-foreground py-20">No oversized tees here yet.</p>
              ) : (
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                  {arr.map((p) => <ProductCard key={p.id} p={p} />)}
                </div>
              )}
            </TabsContent>
          ))}
        </Tabs>
      </div>
    </div>
  );
}
